const Expertise = () => {
  return (
    <div class="gdlr-core-pbf-wrapper expertise-page">
      <div class="gdlr-core-pbf-background-wrap"></div>
      <div class="gdlr-core-pbf-background-wrap" style={{ top: "25px" }}>
        <div class="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js"></div>
      </div>
      <div class="gdlr-core-pbf-wrapper-content gdlr-core-js ">
        <div class="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container">
          <div class="gdlr-core-pbf-column gdlr-core-column-30 gdlr-core-column-first">
            <div
              class="gdlr-core-pbf-column-content-margin gdlr-core-js "
              style={{ margin: "0px 0px 0px 0px" }}
            >
              <div class="gdlr-core-pbf-background-wrap"></div>
              <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js ">
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-title-item gdlr-core-item-pdb clearfix  gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr">
                    <div class="gdlr-core-title-item-title-wrap ">
                      <h3 class="gdlr-core-title-item-title gdlr-core-skin-title">
                        Our Expertise
                        <span class="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>
                      </h3>
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-skill-bar-item gdlr-core-item-pdlr gdlr-core-item-pdb  gdlr-core-size-small gdlr-core-type-round">
                    <div class="gdlr-core-skill-bar">
                      <div class="gdlr-core-skill-bar-head gdlr-core-title-font">
                        <span
                          class="gdlr-core-skill-bar-title"
                          style={{ color: "#181818" }}
                        >
                          Software Engineering
                        </span>
                        <span
                          class="gdlr-core-skill-bar-right"
                          style={{ color: "#8e8e8e" }}
                        >
                          100%
                        </span>
                      </div>
                      <div
                        class="gdlr-core-skill-bar-progress"
                        style={{ backgroundColor: "#dcdcdc" }}
                      >
                        <div
                          class="gdlr-core-skill-bar-filled gdlr-core-js gdlr-core-animate"
                          data-width="100"
                          style={{
                            backgroundColor: "rgb(211, 37, 37)",
                            width: "100%",
                          }}
                        ></div>
                      </div>
                    </div>
                    <div class="gdlr-core-skill-bar">
                      <div class="gdlr-core-skill-bar-head gdlr-core-title-font">
                        <span
                          class="gdlr-core-skill-bar-title"
                          style={{ color: "#181818" }}
                        >
                          Cloud Solutions
                        </span>
                        <span
                          class="gdlr-core-skill-bar-right"
                          style={{ color: "#8e8e8e" }}
                        >
                          95%
                        </span>
                      </div>
                      <div
                        class="gdlr-core-skill-bar-progress"
                        style={{ backgroundColor: "#dcdcdc" }}
                      >
                        <div
                          class="gdlr-core-skill-bar-filled gdlr-core-js gdlr-core-animate"
                          data-width="95"
                          style={{
                            backgroundColor: "rgb(211, 37, 37)",
                            width: "95%",
                          }}
                        ></div>
                      </div>
                    </div>
                    <div class="gdlr-core-skill-bar">
                      <div class="gdlr-core-skill-bar-head gdlr-core-title-font">
                        <span
                          class="gdlr-core-skill-bar-title"
                          style={{ color: "#181818" }}
                        >
                          Data Analytics
                        </span>
                        <span
                          class="gdlr-core-skill-bar-right"
                          style={{ color: "#8e8e8e" }}
                        >
                          80%
                        </span>
                      </div>
                      <div
                        class="gdlr-core-skill-bar-progress"
                        style={{ backgroundColor: "#dcdcdc" }}
                      >
                        <div
                          class="gdlr-core-skill-bar-filled gdlr-core-js gdlr-core-animate"
                          data-width="80"
                          style={{
                            backgroundColor: "rgb(211, 37, 37)",
                            width: "80%",
                          }}
                        ></div>
                      </div>
                    </div>
                    <div class="gdlr-core-skill-bar">
                      <div class="gdlr-core-skill-bar-head gdlr-core-title-font">
                        <span
                          class="gdlr-core-skill-bar-title"
                          style={{ color: "#181818" }}
                        >
                          Mobile App Development
                        </span>
                        <span
                          class="gdlr-core-skill-bar-right"
                          style={{ color: "#8e8e8e" }}
                        >
                          80%
                        </span>
                      </div>
                      <div
                        class="gdlr-core-skill-bar-progress"
                        style={{ backgroundColor: "#dcdcdc" }}
                      >
                        <div
                          class="gdlr-core-skill-bar-filled gdlr-core-js gdlr-core-animate"
                          data-width="80"
                          style={{
                            backgroundColor: "rgb(211, 37, 37)",
                            width: "80%",
                          }}
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="gdlr-core-pbf-column gdlr-core-column-30"
            id="gdlr-core-column-9"
          >
            <div
              class="gdlr-core-pbf-column-content-margin gdlr-core-js "
              style={{ padding: "75px 0px 85px 0px" }}
            >
              <div class="gdlr-core-pbf-background-wrap"></div>
              <div
                class="gdlr-core-pbf-column-content clearfix gdlr-core-js "
                style={{ maxWidth: "550px" }}
              >
                <div class="gdlr-core-pbf-element">
                  <div
                    class="gdlr-core-divider-item gdlr-core-divider-item-normal gdlr-core-item-pdlr gdlr-core-left-align"
                    style={{ marginBottom: "22px" }}
                  >
                    <div
                      class="gdlr-core-divider-container"
                      style={{ maxWidth: "4px" }}
                    >
                      <div class="gdlr-core-divider-line gdlr-core-skin-divider"></div>
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align">
                    <div class="gdlr-core-text-box-item-content">
                      <p>
                        At Prime Wave Technologies LLC, we deliver cutting-edge
                        software solutions tailored to meet your needs. Our
                        expertise in various domains ensures precise and
                        innovative services, making us a trusted partner in the
                        digital age.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Expertise;
